<template lang="pug">
.select-container
  .label-select-padrao(v-if="label") {{ label }}
  el-select(
    :key="`el-select-${value}`"
    v-model="internalValue"
    @change="handleChange"
    placeholder="Selecione"
    class="custom-select"
    popper-class="custom-select-popper"
    :clearable="clearable"
  )
    el-option(
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    )
      div
        .cx-icon
          LucideIcon(v-show="item.value === internalValue" name="Check" :size="16")
        label {{ item.label || item.nome || item.value }}
</template>

<script>
export default {
  name: 'SelectPadrao',
  props: {
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    }
  },
  methods: {
    handleChange(val) {
      this.internalValue = val
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
.select-container {
  width: 100%;

  .label-select-padrao{
    text-align: left;
    color: #9ca3af;
    line-height: 30px;
    font-size: 14px;
  }
}
</style>
